import type { FC } from 'react'
import React from 'react'
import classnames from 'classnames'
import { AgentBanner } from '@/components/banners/AgentBanner'
import type { ILandingAgentBannerProps } from './types'
import './styles.scss'

export const LandingAgentBanner: FC<ILandingAgentBannerProps> = ({ isMFOPage, className }) => {
  const classNames = classnames('landingAgentBanner', className, {
    'landingAgentBanner--mfo': isMFOPage,
  })

  return (
    <section className={classNames}>
      <div className="page-wrapper">
        <AgentBanner />
      </div>
    </section>
  )
}
